import type { ConfirmOptions } from 'material-ui-confirm';

// Initial focus goes to the least destructive action, so Enter on open never
// confirms by accident (WAI-ARIA APG dialog pattern).
export const confirmDefaultOptions: ConfirmOptions = {
  cancellationButtonProps: {
    autoFocus: true,
    // Browsers skip :focus-visible when a script moves focus right after a
    // mouse click, so a dialog opened by a click would hide the focus ring.
    action: (actions) => actions?.focusVisible(),
  },
};
